var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoConstructora(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo_Mas_developers-White",
    "data-name": "Logo_Mas developers-White",
    xmlns: "http://www.w3.org/2000/svg",
    width: 284.681,
    height: 118.146,
    viewBox: "0 0 284.681 118.146",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(114.96 95.808)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_373",
    "data-name": "Path 373",
    className: "cls-1",
    d: "M338.116,289.87l-.019-7.117-3.492,5.864h-1.234l-3.477-5.731v6.965H327.32V278h2.269l4.443,7.373L338.4,278h2.254l.034,11.862Z",
    transform: "translate(-327.32 -277.297)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_374",
    "data-name": "Path 374",
    className: "cls-1",
    d: "M375,287.329h-5.509l-1.039,2.541H365.64L370.916,278h2.709l5.307,11.862h-2.884Zm-.867-2.071-1.861-4.554-1.91,4.554Z",
    transform: "translate(-351 -277.297)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_375",
    "data-name": "Path 375",
    className: "cls-1",
    d: "M401.23,288.373l.932-2.067a6.972,6.972,0,0,0,3.912,1.238c1.628,0,2.292-.543,2.292-1.272,0-2.22-6.877-.7-6.877-5.1,0-2.017,1.628-3.694,5-3.694a7.943,7.943,0,0,1,4.118,1.051l-.844,2.086a6.72,6.72,0,0,0-3.289-.932c-1.628,0-2.254.611-2.254,1.356-.019,2.189,6.858.68,6.858,5.043,0,1.983-1.643,3.679-5.031,3.679A8.533,8.533,0,0,1,401.23,288.373Z",
    transform: "translate(-372.993 -276.973)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_376",
    "data-name": "Path 376",
    className: "cls-1",
    d: "M445,276.16h1.119v15.862H445Z",
    transform: "translate(-400.042 -276.16)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_377",
    "data-name": "Path 377",
    className: "cls-1",
    d: "M469.68,278h4.829c3.8,0,6.353,2.441,6.353,5.933s-2.556,5.929-6.353,5.929H469.68Zm4.76,10.777c3.152,0,5.188-2,5.188-4.844s-2.036-4.848-5.188-4.848h-3.492v9.692Z",
    transform: "translate(-415.293 -277.297)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_378",
    "data-name": "Path 378",
    className: "cls-1",
    d: "M514.685,288.785v1.085h-8.4V278h8.134v1.085h-6.877v4.222h6.136v1.066h-6.124v4.4Z",
    transform: "translate(-437.91 -277.297)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_379",
    "data-name": "Path 379",
    className: "cls-1",
    d: "M542.374,278l-5.253,11.862h-1.238L530.63,278h1.356l4.542,10.315L541.113,278Z",
    transform: "translate(-452.957 -277.297)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_380",
    "data-name": "Path 380",
    className: "cls-1",
    d: "M574.246,288.785v1.085H565.86V278h8.134v1.085h-6.877v4.222h6.132v1.066h-6.136v4.4Z",
    transform: "translate(-474.728 -277.297)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_381",
    "data-name": "Path 381",
    className: "cls-1",
    d: "M595.53,278h1.257v10.777h6.644v1.085h-7.9Z",
    transform: "translate(-493.063 -277.297)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_382",
    "data-name": "Path 382",
    className: "cls-1",
    d: "M618.29,283.792a6.232,6.232,0,1,1,6.239,6.032A5.97,5.97,0,0,1,618.29,283.792Zm11.2,0a4.8,4.8,0,1,0-1.424,3.528,4.8,4.8,0,0,0,1.424-3.528Z",
    transform: "translate(-507.128 -277.149)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_383",
    "data-name": "Path 383",
    className: "cls-1",
    d: "M667.547,282.076c0,2.525-1.83,4.05-4.844,4.05h-3.186v3.744H658.26V278H662.7C665.717,278,667.547,279.528,667.547,282.076Zm-1.253,0c0-1.91-1.253-2.984-3.626-2.984h-3.152v5.933h3.152C665.037,285.026,666.294,283.941,666.294,282.076Z",
    transform: "translate(-531.828 -277.297)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_384",
    "data-name": "Path 384",
    className: "cls-1",
    d: "M698.035,288.785v1.085h-8.4V278h8.164v1.085h-6.877v4.222h6.113v1.066h-6.113v4.4Z",
    transform: "translate(-551.213 -277.297)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_385",
    "data-name": "Path 385",
    className: "cls-1",
    d: "M727.449,289.87l-2.709-3.82a8.347,8.347,0,0,1-.951.053H720.6v3.759H719.35V278H723.8c3.018,0,4.848,1.528,4.848,4.069a3.679,3.679,0,0,1-2.713,3.729l2.9,4.065Zm-.065-7.794c0-1.91-1.257-2.984-3.629-2.984H720.6v5.948h3.152C726.127,285.041,727.384,283.941,727.384,282.076Z",
    transform: "translate(-569.579 -277.297)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_386",
    "data-name": "Path 386",
    className: "cls-1",
    d: "M748.45,288.281l.493-.967a5.815,5.815,0,0,0,3.92,1.444c2.22,0,3.182-.932,3.182-2.1,0-3.255-7.3-1.257-7.3-5.647,0-1.742,1.356-3.251,4.371-3.251a6.712,6.712,0,0,1,3.679,1.051l-.424,1a6.112,6.112,0,0,0-3.255-.986c-2.17,0-3.137.967-3.137,2.155,0,3.251,7.3,1.287,7.3,5.608,0,1.746-1.391,3.236-4.42,3.236A6.435,6.435,0,0,1,748.45,288.281Z",
    transform: "translate(-587.561 -277.148)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_387",
    "data-name": "Path 387",
    className: "cls-1",
    d: "M154.612,276.412H118.62V240.42h35.992Zm-35.228-.764h34.464V241.184H119.384Z",
    transform: "translate(-83.392 -158.266)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_388",
    "data-name": "Path 388",
    className: "cls-1",
    d: "M154.612,184.2H118.62V148.21h35.992Zm-35.228-.764h34.464V148.974H119.384Z",
    transform: "translate(-83.392 -101.284)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_389",
    "data-name": "Path 389",
    className: "cls-1",
    d: "M154.612,91.992H118.62V56h35.992Zm-35.228-.764h34.464V56.764H119.384Z",
    transform: "translate(-83.392 -44.302)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_390",
    "data-name": "Path 390",
    className: "cls-1",
    d: "M62.4,184.2H26.41V148.21H62.4Zm-35.228-.764H61.638V148.974H27.174Z",
    transform: "translate(-26.41 -101.284)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_391",
    "data-name": "Path 391",
    className: "cls-1",
    d: "M246.807,184.2H210.83V148.21h35.977Zm-35.228-.764h34.464V148.974H211.594Z",
    transform: "translate(-140.374 -101.284)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_392",
    "data-name": "Path 392",
    className: "cls-1",
    d: "M215.77,245.788h-36V209.8h36Zm-35.228-.764h34.464v-34.46H180.534Z",
    transform: "translate(-121.18 -139.344)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_393",
    "data-name": "Path 393",
    className: "cls-1",
    d: "M215.77,153.582h-36V117.59h36Zm-35.228-.764h34.464V118.354H180.534Z",
    transform: "translate(-121.18 -82.362)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_394",
    "data-name": "Path 394",
    className: "cls-1",
    d: "M215.77,61.372h-36V25.38h36Zm-35.228-.764h34.464V26.144H180.534Z",
    transform: "translate(-121.18 -25.38)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    className: "cls-1",
    d: "M123.552,153.582H87.56V117.59h35.992Zm-35.228-.764h34.464V118.354H88.324Z",
    transform: "translate(-64.198 -82.362)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_396",
    "data-name": "Path 396",
    className: "cls-1",
    d: "M307.984,153.582H272V117.59h35.992Zm-35.228-.764H307.22V118.354H272.764Z",
    transform: "translate(-178.175 -82.362)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_407",
    "data-name": "Rectangle 407",
    className: "cls-1",
    width: 72.446,
    height: 0.764,
    transform: "translate(11.91 58.727) rotate(-26.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_408",
    "data-name": "Rectangle 408",
    className: "cls-1",
    width: 72.156,
    height: 0.764,
    transform: "translate(47.116 58.753) rotate(-26.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_409",
    "data-name": "Rectangle 409",
    className: "cls-1",
    width: 26.124,
    height: 0.764,
    transform: "translate(0.21 46.966) rotate(-26.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_410",
    "data-name": "Rectangle 410",
    className: "cls-1",
    width: 26.124,
    height: 0.764,
    transform: "translate(105.898 46.964) rotate(-26.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_411",
    "data-name": "Rectangle 411",
    className: "cls-1",
    width: 26.124,
    height: 0.764,
    transform: "translate(105.895 82.191) rotate(-26.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_412",
    "data-name": "Rectangle 412",
    className: "cls-1",
    width: 26.124,
    height: 0.764,
    transform: "translate(35.439 117.42) rotate(-26.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_413",
    "data-name": "Rectangle 413",
    className: "cls-1",
    width: 26.124,
    height: 0.764,
    transform: "translate(70.669 117.419) rotate(-26.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_414",
    "data-name": "Rectangle 414",
    className: "cls-1",
    width: 26.124,
    height: 0.764,
    transform: "translate(35.443 11.736) rotate(-26.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_415",
    "data-name": "Rectangle 415",
    className: "cls-1",
    width: 26.124,
    height: 0.764,
    transform: "translate(70.67 11.735) rotate(-26.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_416",
    "data-name": "Rectangle 416",
    className: "cls-1",
    width: 26.124,
    height: 0.764,
    transform: "translate(0.207 82.193) rotate(-26.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_417",
    "data-name": "Rectangle 417",
    className: "cls-1",
    width: 72.446,
    height: 0.764,
    transform: "translate(11.911 93.953) rotate(-26.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_418",
    "data-name": "Rectangle 418",
    className: "cls-1",
    width: 72.446,
    height: 0.764,
    transform: "translate(47.137 93.956) rotate(-26.84)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_397",
    "data-name": "Path 397",
    className: "cls-1",
    d: "M93.042,215H57.05V179H93.042Zm-35.228-.764H92.278V179.764H57.814Z",
    transform: "translate(-45.344 -120.311)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_398",
    "data-name": "Path 398",
    className: "cls-1",
    d: "M262.222,129.342H226.23V93.35h35.992Zm-35.228-.764h34.464V94.114H226.994Z",
    transform: "translate(-149.891 -67.383)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoConstructora);
export default __webpack_public_path__ + "static/media/logo-constructora.02539e9dcb5cfbb815c1c40a9782de35.svg";
export { ForwardRef as ReactComponent };